module.exports = __webpack_public_path__ + "static/media/polygon.9737e3a0.png";